import React, { useEffect, createElement } from 'react';
export function FacebookPixel() {
  useEffect(() => {
    // Facebook Pixel Base Code
    const pixelId = '519473520973179';
    // Create and initialize Facebook Pixel
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Use document.head instead of trying to insert before a potentially non-existent script
      document.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize pixel with your ID
    fbq('init', pixelId);
    // Track page view
    fbq('track', 'PageView');
    // Add the noscript version as well
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    // Clean up function
    return () => {
      // Not removing the script on unmount as it would break tracking
      // This is standard practice for analytics scripts
    };
  }, []);
  return null; // This component doesn't render anything
}